import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import SeasonRow from 'app/components/season/SeasonRow';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {fetchCupHistory} from 'app/routes/cup/CupPageActions';
import {CupHistoryPageReducer} from 'app/routes/cup/CupPageReducer';
import {LoadingIndicator, LOADING_MESSAGE} from '@fupa/fupa-uikit';
import {AdSlot} from 'app/components/ads/AdSlot';
import {LinkToCompetition} from 'app/components/links/LinkToCompetition';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const CupHistoryPage = ({defaultTitle, districtName, dispatchRedux}) => {
  const {restoredData} = useRestoreData('CupHistoryPage');
  const {cupSlug} = useParams();

  const initialState = restoredData ?? {
    isFetching: false,
    items: [],
  };
  const [state, dispatch] = useReducer(CupHistoryPageReducer, initialState);
  const loadData = () => fetchCupHistory(cupSlug, dispatchRedux)(dispatch, state);
  useFetchData(state, loadData, 'CupHistoryPage');
  const {items, isFetching} = state;

  const meta = [
    {
      name: 'description',
      content: `Alle Archiv-Saisons mit Turnier-Siegern und Vizemeister des Turniers ${defaultTitle} - Kreis ${districtName}.`,
    },
    {name: 'robots', content: 'index, follow'},
  ];

  const SeasonRows = items.map(competitionSeason => {
    return (
      <LinkToCompetition competitionType='cup' competition={competitionSeason} key={competitionSeason.season.slug}>
        <SeasonRow season={competitionSeason} />
      </LinkToCompetition>
    );
  });

  if (items.length > 0) {
    SeasonRows.length > 1 ? SeasonRows.splice(2, 0, <AdSlot key='Content_1' adUnit='Content_1' />) : null;
    SeasonRows.length > 5 ? SeasonRows.splice(6, 0, <AdSlot key='Rectangle_1' adUnit='Rectangle_1' />) : null;
  }

  const content = isFetching ? <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor={false} /> : SeasonRows;

  return (
    <ContentAdDesktop superbannerOnly top='7.125rem' bgColor>
      <Helmet title='Chronik - ' meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

CupHistoryPage.propTypes = {
  defaultTitle: string.isRequired,
  districtName: string.isRequired,
};

export default CupHistoryPage;
